



































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { OwnIncomeResponse, OwnIncomeRow } from '../table-data/OwnIncomeTableData'
import { formatDigitsGrouping } from '../../../common/utils/formattingUtils'

@Component
export default class ReportOwnIncome extends Vue {

    @Prop({ type: Object, required: true })
    public readonly tableData!: OwnIncomeResponse

    @Prop({ type: Boolean, default: false })
    public readonly roundUp!: boolean

    @Prop({ type: Number, default: null })
    public readonly roundUpTo!: number | null

    private get report(): OwnIncomeResponse {
        return this.tableData
    }

    private get locale(): string {
        return this.$i18n.locale
    }

    private get monthKeys(): string[] {
        const prefix = 'modules.budget_execution_monitoring.reports_constructor'
        return [
            `${prefix}.month1`,
            `${prefix}.month2`,
            `${prefix}.month3`,
            `${prefix}.month4`,
            `${prefix}.month5`,
            `${prefix}.month6`,
            `${prefix}.month7`,
            `${prefix}.month8`,
            `${prefix}.month9`,
            `${prefix}.month10`,
            `${prefix}.month11`,
            `${prefix}.month12`,
        ]
    }

    private get rows1(): OwnIncomeRow[] {
        return (this.report.block1?.rows ?? []).filter(r => this.hasData(r))
    }

    private get rows2(): OwnIncomeRow[] {
        return (this.report.block2?.rows ?? []).filter(r => this.hasData(r))
    }

    private get rows3(): OwnIncomeRow[] {
        return (this.report.block3?.rows ?? []).filter(r => this.hasData(r))
    }

    private formatValue(value: number | null | undefined): string {
        if (value === null || value === undefined) return ''
        let rounded: number
        if (this.roundUp && this.roundUpTo != null) {
            const factor = Math.pow(10, this.roundUpTo)
            rounded = Math.round(value * factor) / factor
        } else {
            rounded = Math.round(value * 100) / 100
        }
        return formatDigitsGrouping(rounded)
    }

    private deviationClass(value: number | null | undefined): string {
        if (value === null || value === undefined) return ''
        return value < 0 ? 'text-danger' : ''
    }

    private hasData(row: OwnIncomeRow): boolean {
        const nz = (v: number | null | undefined) => v !== null && v !== undefined && v !== 0
        return nz(row.plan) || nz(row.fact) || row.months.some(nz)
    }
}
